import React from 'react';
import ReactDOM from 'react-dom/client';
// DÜZELTME: HashRouter yerine BrowserRouter'a geri dönüyoruz (Daha modern ve temiz URL)
import { BrowserRouter } from 'react-router-dom'; 

// Slider Kütüphanesinin CSS'leri
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import './App.css'; // Bizim global CSS dosyamız
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);